import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';

const ReactTableFooter = ({
  rows,
  columns,
  pageSize,
  pageIndex,
  onPageChange,
  onRowsPerPageChange,
  ActionsComponent,
}) => {
  const handleChangePage = (event, newPage) => {
    onPageChange(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onRowsPerPageChange(event);
  };

  return (
    <>
      <TableFooter>
        <TableRow>
          <TablePagination
            rowsPerPageOptions={[
              10,
              25,
              50,
              100,
              { label: 'All', value: rows.length },
            ]}
            colSpan={columns.length}
            count={rows.length}
            rowsPerPage={pageSize}
            page={pageIndex}
            SelectProps={{
              inputProps: { 'aria-label': 'rows per page' },
              native: true,
            }}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            ActionsComponent={ActionsComponent}
          />
        </TableRow>
      </TableFooter>
    </>
  );
};

ReactTableFooter.propTypes = {
  rows: PropTypes.any.isRequired,
  columns: PropTypes.any.isRequired,
  pageSize: PropTypes.any.isRequired,
  pageIndex: PropTypes.any.isRequired,
  onPageChange: PropTypes.any.isRequired,
  onRowsPerPageChange: PropTypes.any.isRequired,
  ActionsComponent: PropTypes.any.isRequired,
};

export default ReactTableFooter;
